import { TradeAmountType } from "@modules/shared/domain/entities/trade-amount-type.model";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { Tradable } from "@models/interfaces/tradable";
import { StakingFlowStep } from "@modules/shared/domain/entities/trade-flow.model";
import { Stakeable } from "./stakeable.model";

export interface StakingProcess {
	showPreScreen?: boolean;
	currentStep?: StakingFlowStep;
	selectedPercentage: number;
	stakeable?: Stakeable;
	wallet?: TradableWallet;
	amount?: string;
	amountType?: TradeAmountType;
	error?: boolean;
	termsAccepted?: boolean;
	type?: StakingActionType;
	result?: StakingResult;
	seenEarnTerms?: boolean;
	isLoading: boolean;
}

export enum StakingActionType {
	STAKE,
	UNSTAKE
}

export interface StakingResult {
	// Mock object, the real response in not yet known
	asset: Tradable;
	assetAmount: string;
	fiatAmount: string;
	payoutDate: Date;
}
